import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-neutral-950 text-neutral-100 grid-pattern flex items-center justify-center px-4">
      <div className="max-w-lg w-full bg-neutral-900 border border-neutral-800 rounded p-10 text-center space-y-6">
        <h1 className="font-disp text-4xl uppercase text-white">Checkout Cancelled</h1>
        <p className="text-sm text-neutral-400">
          No charge was made. Your cart is saved — pick up where you left off whenever you're ready.
        </p>
        <Link
          data-testid="cancel-back-to-store-link"
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3 bg-white hover:bg-neutral-200 text-black font-disp uppercase tracking-wider rounded transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to the Shop
        </Link>
      </div>
    </div>
  );
}
